'use strict';

var whichTypedArray = require('which-typed-array');

/** @type {import('.')} */
module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/is-typed-array@1.1.15/~/is-typed-array/index.js
// module id = 648
// module chunks = 0